module.exports = __webpack_public_path__ + "img/skills.76342c3f.svg";